// @flow
import { useMemo } from 'react';

import { useFilterData, getValue } from 'app/common/ui-components/filter';
import { reportTypes, type ReportsPerformBalancesParams } from 'app/common/api/requests/reports/perform';

import orgsOrUserFilter from 'app/components/common/reports/filters/orgsOrUser';
import { orgsOrUser } from 'app/dataTypes/reports/orgsOrUser';

import generateParamsByOrgs from './generateParamsByOrgs';
import generateParamsByUser from './generateParamsByUser';
import generateParamsOptions from './generateParamsOptions';
import type { FilterParams } from '../FilterParams.type';


export type Params = ReportsPerformBalancesParams | null

export default function useGenerateParams(): [Params, boolean] {
  const [,,, { getApplied }, filterParams] = useFilterData<FilterParams>();

  const res: [Params, boolean] = useMemo(() => {
    const applied = getApplied();

    if (applied) {
      const [orgsOrUserTypeSelected] = getValue(orgsOrUserFilter, applied);

      const [options, onlymail] = generateParamsOptions(applied, filterParams);

      const params = (
        orgsOrUserTypeSelected === orgsOrUser.ByOrgs
          ? generateParamsByOrgs(applied)
          : generateParamsByUser(applied)
      );

      return [{
        report_type: reportTypes.REPORT_BALANCES,
        params,
        options,
      }, onlymail];
    }
    return [null, false];
  }, [getApplied, filterParams]);

  return res;
}
